import { i18n } from '@fs/zion-locale'

export default {
  // Coverage errors
  TOO_MANY_COVERAGES: () => i18n.t('EditableCoverages.tooManyCoverages', '10 or more coverages'),
  PLACE_ORIG_TOO_LONG: () =>
    i18n.t(
      'EditableCoverages.placeOrigTooLong',
      'A place of origin in one or more coverages is greater than 75 characters in length'
    ),
  MISSING_PLACE: () => i18n.t('EditableCoverages.missingPlace', 'One or more coverages are missing a place'),
  MISSING_DATE: () => i18n.t('EditableCoverages.missingDate', 'One or more coverages are missing a date'),
  MISSING_RECORD_TYPE: () =>
    i18n.t('EditableCoverages.missingRecordType', 'One or more coverages are missing a record type'),
  UNSTANDARDIZED_PLACE: () =>
    i18n.t('EditableCoverages.unstandardizedPlace', 'One or more coverages have an unstandardized place'),
  UNSTANDARDIZED_DATE: () =>
    i18n.t('EditableCoverages.unstandardizedDate', 'One or more coverages have an unstandardized date'),
  UNSTANDARDIZED_RECORD_TYPE: () =>
    i18n.t('EditableCoverages.unstandardizedRecordType', 'One or more coverages have an unstandardized record type'),
  UNACCEPTABLE_FUTURE_DATE: () =>
    i18n.t(
      'EditableCoverages.unacceptableFutureDate',
      'One or more coverages have a date that is at least a year in the future'
    ),
  UNACCEPTABLE_DATE_RANGE: () =>
    i18n.t('EditableCoverages.unacceptableDateRange', 'One or more coverages have an unacceptable date range'),

  // other text
  errorsHeader: () => i18n.t('EditableCoverages.errorsHeader', 'This group has the following errors:'),
  noErrorsHeader: () =>
    i18n.t(
      'EditableCoverages.noErrorsHeader',
      'Please review this group data for incomplete coverages. If there are no errors mark the coverages as complete.'
    ),
  editAndSaveChanges: () =>
    i18n.t('EditableCoverages.editAndSaveChanges', 'Please review and correct these errors, then save your changes'),
  coverageDataIsComplete: () => i18n.t('EditableCoverages.coverageDataIsComplete', 'Coverages are complete'),
  openAll: () => i18n.t('EditableCoverages.openAll', 'Open All'),
  closeAll: () => i18n.t('EditableCoverages.closeAll', 'Close All'),
  selectAll: () => i18n.t('EditableCoverages.selectAll', 'Select All'),
  selectAllCoveragesLabel: () => i18n.t('EditableCoverages.selectAllCoveragesLabel', 'Select all coverages'),
  placeLabel: () => i18n.t('EditableCoverages.placeAll', 'Place'),
}
